import { domAnimation, LazyMotion, MotionConfig } from 'framer-motion';

/**
 * Raiz de movimento de todas as telas v2.
 *
 * - `domAnimation` em vez do bundle completo: só transform, opacity,
 *   filter e clip-path, que é exatamente o que animamos. Corta a maior
 *   parte do peso do framer-motion.
 * - `strict` quebra o build se alguém importar `motion.div` em vez de
 *   `m.div` — é o que impede o bundle completo de voltar por descuido.
 * - `reducedMotion="user"` desliga tudo no nível da lib, então nenhuma
 *   seção consegue esquecer de respeitar a preferência do sistema.
 */
export const MotionRoot = ({ children }) => (
  <LazyMotion features={domAnimation} strict>
    <MotionConfig reducedMotion="user">{children}</MotionConfig>
  </LazyMotion>
);

export default MotionRoot;
